import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { convertSecondsToMinutesSeconds, getChainData } from "../utils/Utils";
import Chain from "./Chain";
import ChainDiagram from "./ChainDiagram";
import StatisticCodes from "./StatisticCodes";

function EventsList({ match, team, events, onSelectEvent }) {
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState(events);
  const [showCodes, setShowCodes] = useState(false);
  const [showChain, setShowChain] = useState(false);
  const [codeteam, setCodeTeam] = useState(team);
  const [chainEvents, setChainEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const doSelectChainEvent = (e) => {
    setSelectedEvent(e);
    onSelectEvent(e);
  };

  const doShowChain = (e) => {
    if (!team.playerSensorData) {
      toast.error(
        "No sensor data available for this quarter. Please load the data first."
      );
      onSelectEvent(e);
      return;
    }
    setSelectedEvent(null);
    setShowChain(true);
    const chaindata = getChainData(e, team, match);
    // const chainid = e["INITIAL_TRX_ID"];
    // const evs = events.filter((event) => {
    //   return event["INITIAL_TRX_ID"] === chainid;
    // });

    // const period = parseInt(e["PERIOD"]);
    // const catapultOffset = match.periods[period - 1].catapultOffset;
    // const starttime =
    //   match.home_catapult_session?.periods[period - 1].start_time +
    //   catapultOffset;

    // let lastev = null;
    // for (var ev of evs) {
    //   const plid = ev["PERSON_ID"];
    //   const pls = team.cdplayers.filter((p) => {
    //     return p.id === plid;
    //   });
    //   if (pls.length > 0) {
    //     const athlete_id = pls[0].athlete_id;
    //     const sds = team.playerSensorData[period - 1].filter((sd) => {
    //       return sd.id === athlete_id;
    //     });
    //     const sdx = sds[0];
    //     if (sdx && sdx.data) {
    //       for (var sd of sdx.data.data) {
    //         const sdtime = sd.ts + sd.cs / 100;
    //         const etime =
    //           parseInt(ev["PERIOD_SECS"]) +
    //           parseFloat(match.periods[period - 1].firstBounceVideoTime);
    //         if (sdtime >= starttime + etime) {
    //           ev["chainx"] = sd.x;
    //           ev["chainy"] = sd.y;
    //           if (lastev) {
    //             const lastx = lastev["chainx"];
    //             const lasty = lastev["chainy"];
    //             // distance
    //             let dist = 0;
    //             if ((ev["STATISTIC_CODE"] === "GOAL") ||
    //                 (ev["STATISTIC_CODE"].substring(0, 3) === "RUS") ||
    //                 (ev["STATISTIC_CODE"] === "BEHI")) 
    //              {
    //               const halflength = parseInt(match.venueLength) / 2;
    //               if (lastx <= 0) {
    //                 dist = Math.sqrt(
    //                   Math.pow(-halflength - lastx, 2) + Math.pow(0 - lasty, 2)
    //                 );
    //               } else {
    //                 dist = Math.sqrt(
    //                   Math.pow(halflength - lastx, 2) + Math.pow(0 - lasty, 2)
    //                 );
    //               }
    //             } else {
    //               dist = Math.sqrt(
    //                 Math.pow(sd.x - lastx, 2) + Math.pow(sd.y - lasty, 2)
    //               );
    //             }
    //             lastev["distance"] = dist;
    //           }
    //           lastev = ev;
    //           break;
    //         }
    //       }
    //     }
    //   }
    // }
    // const chaindata = {
    //   chainId: chainid,
    //   chainSquad: e["CHAIN_SQUAD"],
    //   events: evs,
    // };
    // compress chaindata
    // const zipchaindata = compress(JSON.stringify(chaindata));
    // console.log(zipchaindata.length);

    setChainEvents(chaindata);
    onSelectEvent(chaindata.events[0]);
  };

  const doShowCodes = () => {
    setShowCodes(true);
  };

  const doSelectedCode = (code, t) => {
    setShowCodes(false);
    if (t === team) {
      doSearch(code);
    }
  };

  const doSearch = (text) => {
    setSearchText(text);
    const filtered = events.filter((event) => {
      return (
        event["STATISTIC_CODE"].toLowerCase().includes(text.toLowerCase()) ||
        event["STATISTIC_CODE"].toLowerCase().includes(text.toLowerCase())
      );
    });
    setFilteredEvents(filtered);
  };

  const handleSearchText = (text) => {
    doSearch(text);
  };

  useEffect(() => {
    console.log(events);
  }, [events, showCodes]);

  return (
    <>
      {showCodes ? (
        <>
          {" "}
          <StatisticCodes
            team={team}
            onSelectedCode={(code, team) => doSelectedCode(code, team)}
          />
        </>
      ) : (
        <>
          {showChain ? (
            <>
              <div className="flex gap-1">
                <ChainDiagram
                  panelSize={{ width: 160, height: 300 }}
                  groundSize={{
                    width: match.venueWidth,
                    height: match.venueLength,
                  }}
                  match={match}
                  teamA={null}
                  teamB={null}
                  selectedPeriod={1}
                  videoProgress={0}
                  catapultOffset={0}
                  showNames={false}
                  selectedPlayers={null}
                  currentChain={chainEvents}
                  selectedEvent={selectedEvent}
                  // onSensorData={(sdata) => doUpdateSensorData(sdata)}
                />
                <Chain
                  chain={chainEvents}
                  onSelectEvent={(e) => doSelectChainEvent(e)}
                  onChainCancel={() => {
                    setShowChain(false);
                  }}
                />
              </div>
            </>
          ) : (
            <div className="flex-col">
              <div className="flex gap-2">
                <input
                  type="text"
                  className="input-generic w-full max-w-xs"
                  value={searchText}
                  onChange={(e) => {
                    handleSearchText(e.target.value);
                  }}
                  placeholder="Search events"
                />
                <InformationCircleIcon
                  className="size-8 mt-1 text-base-content cursor-pointer"
                  onClick={() => doShowCodes()}
                />
              </div>
              <div className="flex-col h-[24vh] overflow-auto mt-1 shadow-lg  bg-base-200/80">
                <table className="table-generic w-full">
                  <thead>
                    <tr>
                      <th className="text-left">Player</th>
                      <th className="text-left">Time</th>
                      <th className="text-left">Event</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredEvents.map((e, idx) => (
                      <tr
                        key={idx}
                        className={
                          idx % 2 !== 0
                            ? "px-1 py-0.5 cursor-pointer"
                            : "px-1 py-0.5 bg-base-300/50 cursor-pointer"
                        }
                        onClick={() => {
                          doShowChain(e);
                        }}
                      >
                        <td>{e["FULLNAME"]}</td>
                        <td className="text-left">
                          {convertSecondsToMinutesSeconds(e["PERIOD_SECS"])}
                        </td>
                        <td>{e["STATISTIC_CODE"]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default EventsList;
